<template>

  <div>
    <div uk-grid class="uk-grid uk-grid-gap-small uk-child-width-1-2@s uk-child-width-1-4@m">


      <div class="">
        <div class="uk-form-control uk-form-control-large">
          <span class="uk-form-icon uk-form-icon-flip" uk-icon="search"></span>
          <input type="search" :placeholder="sfModel.BackgroundHint" class="uk-input uk-box-shadow-medium" v-model="searchQuery" @change="filterChange" aria-autocomplete="both"/>
        </div>
      </div>

      <div class="">
        <input-checkboxes
            class="uk-form-control uk-form-control-large"
            v-model="selectedCategories"
            :key="selectedCategories"
            @change="filterChange"
            :options="categories"
            :optionLabelKey="optionLabelKey"
            :optionChildrenKey="optionChildrenKey"
            :label="l('Category')"
            name="categories"
        />
      </div>

      <div class="">
        <input-checkboxes
            class="uk-form-control uk-form-control-large"
            v-model="selectedAssetTypes"
            :key="selectedAssetTypes"
            @change="filterChange"
            :options="assetTypes"
            :optionLabelKey="optionLabelKey"
            :optionChildrenKey="optionChildrenKey"
            :label="l('AssetType')"
            name="assettypes"
        />
      </div>


      <div class="">
        <input-checkboxes
            class="uk-form-control uk-form-control-large"
            v-model="selectedMediaTypes"
            :key="selectedMediaTypes"
            @change="filterChange"
            :options="mediaTypes"
            :optionLabelKey="optionLabelKey"
            :optionChildrenKey="optionChildrenKey"
            :label="l('MediaType')"
            name="mediatypes"
        />
      </div>



    </div>
  </div>

</template>
<script setup>
import {onMounted, ref} from 'vue'
import InputCheckboxes from "./input-checkboxes.vue";
import {searchResults} from "./index";
import {sfUtil} from "../../util";

const props = defineProps({
  sfModel: Object,
  taxonomies: Object,
})

const l = window.l

let taxonomies = {...props.taxonomies}
let mediaTypes = taxonomies['mediatypes']
let assetTypes = taxonomies['assettypes']
let categories = taxonomies['categories']

let searchQuery = ref('')
let selectedMediaTypes = ref(new Set());
let selectedAssetTypes = ref(new Set());
let selectedCategories = ref(new Set());

let initialResultsHtml = null

const MEDIA_TYPES = 'media-types'
const ASSET_TYPES = 'marketing-materials-type'
const CATEGORIES = 'Categories'

const {
  optionLabelKey,
  optionValueKey,
  optionChildrenKey,
  getSearchParams,
  filterChildren,
  objectByValueKeys,
  findSearchResultsContainer
} = sfUtil.useBaseSearch();

const searchResultsContainer = findSearchResultsContainer()

onMounted(() => {
  window.addEventListener('popstate', () => {
    updateSearchResults()
  })

  if (searchResultsContainer && !sfUtil.hasActiveFiltering()) {
    initialResultsHtml = searchResultsContainer.innerHTML
  }
})

let initFilterState = () => {
  let searchParams = getSearchParams()
  searchQuery.value = searchParams.get('searchQuery')
  selectedMediaTypes.value = objectByValueKeys(new Set(searchParams.get(MEDIA_TYPES)?.split(',')), mediaTypes)
  selectedAssetTypes.value = objectByValueKeys(new Set(searchParams.get(ASSET_TYPES)?.split(',')), assetTypes)
  selectedCategories.value = objectByValueKeys(new Set(searchParams.get(CATEGORIES)?.split(',')), categories)
}

window.addEventListener('popstate', () => {
  initFilterState()
})

initFilterState()

let filterChange = () => {

  const url = new URL(window.location);

  let mediaTypesSearch = [...selectedMediaTypes.value].map(v => v[optionValueKey]).join(',')
  let assetTypesSearch = [...selectedAssetTypes.value].map(v => v[optionValueKey]).join(',')

  let categoriesSearch = [...filterChildren(categories, selectedCategories.value)].map(v => v[optionValueKey]).join(',')

  if (categoriesSearch) {
    url.searchParams.set(CATEGORIES, categoriesSearch)
  } else {
    url.searchParams.delete(CATEGORIES)
  }

  if (mediaTypesSearch) {
    url.searchParams.set(MEDIA_TYPES, mediaTypesSearch)
  } else {
    url.searchParams.delete(MEDIA_TYPES)
  }

  if (assetTypesSearch) {
    url.searchParams.set(ASSET_TYPES, assetTypesSearch)
  } else {
    url.searchParams.delete(ASSET_TYPES)
  }

  if (mediaTypesSearch || assetTypesSearch || categoriesSearch || searchQuery.value) {
    url.searchParams.set('searchQuery', searchQuery.value || '')
    url.searchParams.set('language', props.sfModel['Language'])
  } else {
    url.searchParams.delete('searchQuery')
    url.searchParams.delete('language')
  }

  if (url.searchParams.has('searchQuery')) {
    url.searchParams.set('indexCatalogue', props.sfModel['IndexCatalogue'])
  } else {
    url.searchParams.delete('indexCatalogue')
  }



  url.pathname = url.pathname.replace(sfUtil.sfPathnamePagingRegex, '')

  url.searchParams.delete('page')

  window.history.pushState({}, '', url);

  updateSearchResults()
}

let updateSearchResults = () => {
  initSearchResults()
  document.dispatchEvent(new Event('searchPredicateChanged'))
}

let searchResultsApp = null

let initSearchResults = () => {
  if (searchResultsApp) return
  searchResultsApp = Vue.createApp(searchResults, {initialResultsHtml})
  searchResultsApp.mount(searchResultsContainer)
  window.searchResultApp = searchResultsApp
}

</script>
